import { z } from "zod";

export const requiredString = (label: string): z.ZodString =>
  z.string().trim().min(1, `${label} is required`);

export const positiveNumber = (label: string): z.ZodCoercedNumber =>
  z.coerce.number().positive(`${label} must be greater than 0`);

export const nonNegativeNumber = (label: string): z.ZodCoercedNumber =>
  z.coerce.number().nonnegative(`${label} cannot be negative`);

// Optional numeric field bound to a `type="number"` input. An emptied number
// input can surface as "", undefined, or NaN depending on the browser/RHF path —
// all of which mean "no value" (null), not 0 and not a validation error. A real
// number still validates and must be non-negative.
export const optionalNonNegativeNumber = (
  label: string,
): z.ZodType<number | null> =>
  z.preprocess(
    (value) =>
      value === null ||
      value === undefined ||
      (typeof value === "string" && value.trim() === "") ||
      (typeof value === "number" && Number.isNaN(value))
        ? null
        : value,
    z.coerce.number().nonnegative(`${label} cannot be negative`).nullable(),
  );

export const nameSlug = (label: string): z.ZodString =>
  z
    .string()
    .trim()
    .min(1, `${label} is required`)
    .regex(
      /^[a-zA-Z0-9 \-'.()]+$/,
      "Only letters, numbers, spaces, hyphens, apostrophes, periods and parentheses are allowed",
    );

export const emailField = z.email("Invalid email").trim().min(1, "Email is required");
